/* TaPanda: one-photo custom changes, explicitly scoped storefront module.
   Enabled only by explicit photo/text layer IDs on the product section.
   Reuses the original File through the native upload flow; scoped IndexedDB
   recovery preserves it across reloads without private SDK calls. */
(function (host, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory(null);
  else factory(host);
})(typeof window === 'object' ? window : null, function (win) {
  'use strict';

  var DEFAULT_TEXT = 'Zachowaj podstawowy styl projektu';
  var TIMEOUT_MS = 180000;
  var SOURCE_TTL_MS = 86400000;
  var SOURCE_MAX_BYTES = 20 * 1024 * 1024;
  var SOURCE_CACHE_MAX_BYTES = 50 * 1024 * 1024;
  var SOURCE_CACHE_MAX_RECORDS = 6;
  var ROOT_SELECTOR = '[data-tp-custom-changes-photo][data-tp-custom-changes-text]';
  var ATC_SELECTOR = '#teeAtcButton, .tee-btn--atc, #teeBuynowButton, .tee-btn--buynow, [data-tp-custom-changes-atc]';
  var LABELS = {
    summary: 'Chcesz dodać własne zmiany?',
    optional: 'Opcjonalnie',
    choice: 'Chcę dodać własne zmiany (opcjonalne)',
    editorLabel: 'Opisz, co chcesz zmienić',
    placeholder: 'Np. dodaj psa obok nas lub zmień tło na ogród.',
    help: 'Użyjemy wcześniej wgranego zdjęcia. Nie musisz wybierać go ponownie.',
    regenerate: 'Wygeneruj ponownie z moimi zmianami',
    regenerateDefault: 'Wygeneruj ponownie bez własnych zmian',
    generating: 'Tworzymy podgląd…',
    waitGeneration: 'Tworzymy nowy podgląd. Zaczekaj na zakończenie generowania.',
    confirmCrop: 'Potwierdź kadr w oknie zdjęcia, jeśli się pojawi. Potem utworzymy nowy podgląd.',
    browserRetry: 'Nie udało się ponownie użyć zdjęcia w tej przeglądarce. Wgraj je ponownie przyciskiem zdjęcia.',
    timeout: 'Nie udało się potwierdzić nowego podglądu w ciągu 3 minut. Zaczekaj, aż zakończy się przesyłanie, i spróbuj ponownie.',
    waitingForPrevious: 'Poprzednie generowanie jeszcze się nie zakończyło. Zaczekaj; jeśli zostało anulowane, odśwież stronę i wgraj zdjęcie ponownie.',
    generationError: 'Nie udało się utworzyć nowego podglądu. Spróbuj ponownie.',
    uploadFirst: 'Najpierw wgraj swoje zdjęcie przyciskiem powyżej.',
    uploadAgain: 'Aby zmienić ten projekt, wgraj ponownie swoje zdjęcie przyciskiem powyżej.',
    describeChanges: 'Wpisz, co chcesz zmienić, albo odznacz własne zmiany.',
    stale: 'Opis zmienił się. Wygeneruj nowy podgląd przed dodaniem do koszyka.',
    regenerateBeforeCart: 'Najpierw wygeneruj podgląd z moimi zmianami.',
    regenerateDefaultBeforeCart: 'Wygeneruj podgląd ponownie przed dodaniem projektu do koszyka.',
    readyCustom: 'Twoje zmiany są uwzględnione w podglądzie.',
    readyDefault: 'Podgląd jest gotowy.',
    resetChanges: 'Wgraj zdjęcie ponownie, aby wrócić do projektu bez własnych zmian.',
    chooseAnotherPhoto: 'Wybierz inne zdjęcie',
    uploadPhoto: 'Dodaj zdjęcie',
    photoDetailsChanged: 'Dane projektu zmieniły się po przetworzeniu zdjęcia. Wgraj je ponownie.',
    removePhoto: 'Usuń zdjęcie',
    currentProject: 'Aktualny projekt',
    confirmRemovePhoto: 'Czy na pewno chcesz usunąć swoje zdjęcie?',
    deletePhoto: 'Usuń',
    keepPhoto: 'Zostaw'
  };

  function parseLabels(raw) {
    var translated = {};
    try { translated = JSON.parse(raw || '{}'); } catch (_error) { /* Keep Polish fallback. */ }
    var result = {};
    Object.keys(LABELS).forEach(function (key) {
      result[key] = translated && typeof translated[key] === 'string' && translated[key].trim()
        ? translated[key] : LABELS[key];
    });
    return result;
  }
  function escape(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function resolveRequestedText(enabled, value) {
    var custom = String(value == null ? '' : value).trim();
    // An empty optional editor must never cancel the first native photo upload.
    // Only a non-empty description changes the generation's prompt identity.
    return enabled && custom ? custom : DEFAULT_TEXT;
  }

  function nativeErrorKey(snapshot) {
    return snapshot && snapshot.error ? String(snapshot.errorKey || 'native-error') : '';
  }
  function isPhotoDetailsChanged(value, translated) {
    value = String(value || '').trim().replace(/^\*\s*/, '').replace(/\s+/g, ' ');
    return value === 'Your details changed after this photo was processed. Please upload it again.' ||
      value === (translated || LABELS.photoDetailsChanged) ||
      value === 'Wiek został zmieniony. Wgraj zdjęcie ponownie, aby wygenerować nowy projekt.';
  }
  function generationErrorKey(snapshot) {
    if (!snapshot || !snapshot.error) return '';
    if (typeof snapshot.generationErrorKey === 'string') return snapshot.generationErrorKey;
    var key = nativeErrorKey(snapshot);
    return key === 'photo-details-changed' ? '' : key;
  }
  function newNativeError(attempt, snapshot) {
    var key = generationErrorKey(snapshot);
    // The SDK can add its stale-input hint asynchronously after begin() while
    // opening the original crop. This is not a generation failure. It still
    // blocks success through snapshot.error until the new result clears it.
    if (!key) { attempt.errorCleared = true; return false; }
    return !attempt.beforeError || attempt.errorCleared || key !== attempt.beforeErrorKey;
  }

  function acceptedReceipt(record) {
    var receipt = record && record.acceptedRequest;
    // A draft and a restored thumbnail are not a receipt. This record is only
    // written with the original File after an observed successful request.
    if (!receipt || Array.isArray(receipt) || receipt.version !== 1 ||
        receipt.scope !== record.key || receipt.sourceId !== record.sourceId ||
        receipt.processedUrl !== record.processedUrl ||
        typeof receipt.requestText !== 'string' || !receipt.requestText.trim() || receipt.requestText.length > 500 ||
        typeof receipt.context !== 'string' || receipt.context.length > 12000) return null;
    return { version: 1, scope: receipt.scope, sourceId: receipt.sourceId, processedUrl: receipt.processedUrl,
      requestText: receipt.requestText, context: receipt.context };
  }

  function createSourceCache(host, now) {
    now = now || Date.now;
    var database = null;
    var opening = null;
    var queue = Promise.resolve();
    function open() {
      if (!host || !host.indexedDB) return Promise.resolve(null);
      if (opening) return opening;
      opening = new Promise(function (resolve) {
        var request;
        var settled = false;
        var timeout = host.setTimeout(function () { finish(null); }, 4000);
        function finish(db) {
          if (settled) { if (db) db.close(); return; }
          settled = true;
          host.clearTimeout(timeout);
          database = db;
          resolve(db);
        }
        try { request = host.indexedDB.open('tp-custom-changes-source-v1', 1); }
        catch (_error) { finish(null); return; }
        request.onupgradeneeded = function () {
          if (!request.result.objectStoreNames.contains('sources')) request.result.createObjectStore('sources', { keyPath: 'key' });
        };
        request.onerror = request.onblocked = function () { finish(null); };
        request.onsuccess = function () {
          request.result.onversionchange = function () { request.result.close(); database = null; opening = null; };
          finish(request.result);
        };
      });
      return opening;
    }
    function valid(record) {
      return !!record && typeof record.key === 'string' && record.key.length <= 1200 &&
        /^[a-zA-Z0-9_-]{10,80}$/.test(record.sourceId || '') &&
        /^https:\/\/\S+$/.test(record.processedUrl || '') &&
        typeof record.name === 'string' && typeof record.type === 'string' &&
        Number.isFinite(record.lastModified) && Number.isFinite(record.createdAt) &&
        record.createdAt <= now() && record.expiresAt > now() && record.expiresAt <= record.createdAt + SOURCE_TTL_MS &&
        record.blob && typeof record.blob.arrayBuffer === 'function' && typeof record.blob.slice === 'function' &&
        Number.isFinite(record.blob.size) && record.blob.size > 0 && record.blob.size <= SOURCE_MAX_BYTES;
    }
    function readAll(db) {
      return new Promise(function (resolve, reject) {
        var transaction = db.transaction('sources', 'readonly');
        var request = transaction.objectStore('sources').getAll();
        var records = [];
        request.onsuccess = function () { records = request.result || []; };
        transaction.oncomplete = function () { resolve(records); };
        transaction.onerror = transaction.onabort = function () { reject(transaction.error); };
      });
    }
    function write(db, removed, record) {
      return new Promise(function (resolve, reject) {
        var transaction = db.transaction('sources', 'readwrite');
        var store = transaction.objectStore('sources');
        transaction.oncomplete = function () { resolve(true); };
        transaction.onerror = transaction.onabort = function () { reject(transaction.error); };
        try {
          removed.forEach(function (key) { store.delete(key); });
          if (record) store.put(record);
        } catch (error) { transaction.abort(); reject(error); }
      });
    }
    function bounded(records) {
      var bytes = 0;
      return records.filter(valid).sort(function (a, b) { return b.createdAt - a.createdAt; })
        .filter(function (record, index) {
          if (index >= SOURCE_CACHE_MAX_RECORDS || bytes + record.blob.size > SOURCE_CACHE_MAX_BYTES) return false;
          bytes += record.blob.size;
          return true;
        });
    }
    function run(action) {
      var result = queue.then(open).then(function (db) {
        return db ? action(db) : null;
      }).catch(function () { return null; });
      queue = result.then(function () {});
      return result;
    }
    return {
      get: function (key) {
        return run(function (db) { return readAll(db).then(function (records) {
          var kept = bounded(records);
          var removed = records.filter(function (record) { return kept.indexOf(record) === -1; }).map(function (record) { return record.key; });
          var found = kept.find(function (record) { return record.key === key; }) || null;
          return removed.length ? write(db, removed).then(function () { return found; }) : found;
        }); });
      },
      save: function (key, sourceId, file, processedUrl, active, receipt) {
        var savedAt = now();
        var record = { key: key, sourceId: sourceId, blob: file,
          name: file && file.name || '', type: file && file.type || '', lastModified: file && file.lastModified,
          processedUrl: processedUrl, createdAt: savedAt, expiresAt: savedAt + SOURCE_TTL_MS };
        if (receipt) {
          record.acceptedRequest = receipt;
          record.acceptedRequest = acceptedReceipt(record);
        }
        if (!valid(record)) return Promise.resolve(false);
        return run(function (db) { return readAll(db).then(function (records) {
          if (active && !active()) return false;
          var kept = bounded([record].concat(records.filter(function (previous) { return previous.key !== key; })));
          if (kept.indexOf(record) === -1) return false;
          var removed = records.filter(function (previous) { return !kept.some(function (candidate) { return candidate.key === previous.key; }); })
            .map(function (previous) { return previous.key; });
          return write(db, removed, record);
        }); });
      },
      remove: function (key) { return run(function (db) { return write(db, [key]); }); },
      close: function () { if (database) database.close(); database = null; opening = null; }
    };
  }

  function createModel(now) {
    now = now || Date.now;
    var model = {
      file: null, revision: 0, requestedText: DEFAULT_TEXT,
      validText: true, context: '', validContext: true, successfulKey: null, attempt: null,
      epoch: 0, error: '', observedUrl: '', previewMismatch: false, photoWasCleared: false, unsettled: null, restored: null
    };
    model.key = function () { return JSON.stringify([model.revision, model.requestedText, model.context]); };
    model.setSource = function (file) {
      model.file = file || null;
      model.revision += 1;
      if (!model.unsettled) model.error = '';
      model.photoWasCleared = false;
      model.restored = null;
    };
    model.setText = function (text, valid) {
      model.requestedText = String(text == null ? '' : text);
      model.validText = valid !== false;
    };
    model.setContext = function (identity, valid) {
      model.context = String(identity == null ? '' : identity);
      model.validContext = valid !== false;
    };
    model.restore = function (snapshot) {
      // Native restoration is not a newly observed generation. Delegate its
      // unchanged validation to Teeinblue, and pin the visible image/prompt so
      // history or later edits cannot silently approve a different project.
      if (model.restored || model.file || model.revision || model.successfulKey !== null ||
          model.pending() || model.unsettled || model.photoWasCleared || !snapshot ||
          snapshot.busy || snapshot.error || !snapshot.uploaded || !snapshot.url) return false;
      model.restored = { key: model.key(), url: snapshot.url };
      return true;
    };
    model.pending = function () { return !!model.attempt; };
    model.blocked = function () {
      return model.pending() || !!model.unsettled || !!model.error || !model.validText || !model.validContext || model.previewMismatch || model.photoWasCleared ||
        (model.restored !== null && model.restored.key !== model.key()) ||
        (model.successfulKey !== null && model.successfulKey !== model.key()) ||
        (model.successfulKey === null && !!model.file) ||
        (model.successfulKey === null && model.restored === null && model.requestedText !== DEFAULT_TEXT);
    };
    model.begin = function (snapshot) {
      if (model.pending() || model.unsettled || !model.file || !model.validText || !model.validContext || (snapshot && snapshot.busy)) return null;
      model.epoch += 1;
      model.error = '';
      model.attempt = {
        epoch: model.epoch, key: model.key(), startedAt: now(), sawBusy: false,
        beforeUrl: snapshot && snapshot.url || '', beforeError: !!generationErrorKey(snapshot),
        beforeErrorKey: generationErrorKey(snapshot), errorCleared: false
      };
      return model.attempt.epoch;
    };
    model.fail = function (epoch, reason) {
      if (!model.attempt || model.attempt.epoch !== epoch) return false;
      // Timeout does not prove that Teeinblue's request stopped. Keep its identity
      // until an observable terminal result; never overlap it with a retry.
      if (reason === 'timeout') model.unsettled = model.attempt;
      model.attempt = null;
      model.error = reason || 'generation';
      return true;
    };
    model.observe = function (snapshot) {
      if (model.unsettled) {
        var previous = model.unsettled;
        if (!snapshot) return null;
        if (snapshot.busy) previous.sawBusy = true;
        var terminalError = newNativeError(previous, snapshot);
        var terminalImage = previous.sawBusy && !snapshot.error && snapshot.uploaded &&
          snapshot.url && snapshot.url !== previous.beforeUrl;
        if (!snapshot.busy && (terminalError || terminalImage)) {
          model.unsettled = null;
          // A late result settles the old request but does not validate a newer
          // photo/description or automatically release the cart after timeout.
          return 'settled';
        }
        return null;
      }
      var attempt = model.attempt;
      if (!attempt) {
        // Native history selection can replace the displayed image without a
        // generation. A prompt key alone does not prove that this image belongs
        // to it; retain approval only for the observed result of that request.
        if (model.successfulKey !== null || model.restored !== null) {
          var approvedUrl = model.successfulKey !== null ? model.observedUrl : model.restored.url;
          model.previewMismatch = !snapshot || snapshot.busy || snapshot.error ||
            !snapshot.uploaded || !snapshot.url || snapshot.url !== approvedUrl;
        }
        return model.previewMismatch ? 'preview-mismatch' : null;
      }
      // Crop confirmation can take arbitrarily long without a provider job.
      // Start the generation deadline at its first observable busy cycle.
      if (snapshot && snapshot.busy && !attempt.sawBusy) {
        attempt.sawBusy = true;
        attempt.startedAt = now();
      }
      if (attempt.sawBusy && now() - attempt.startedAt >= TIMEOUT_MS) {
        model.fail(attempt.epoch, 'timeout');
        return 'timeout';
      }
      // Missing fields during a native form replacement are not success or failure.
      if (!snapshot) return null;
      // Native crop/upload phases can keep an old age/prompt warning visible
      // even after the first busy cycle. Only a changed warning, or one that
      // disappeared and returned, proves a failure of this new request.
      var freshError = newNativeError(attempt, snapshot);
      if (freshError && !snapshot.busy) {
        model.fail(attempt.epoch, 'native');
        return 'error';
      }
      if (snapshot.busy) attempt.sawBusy = true;
      if (!snapshot.busy && !snapshot.error && snapshot.uploaded && attempt.sawBusy &&
          snapshot.url && snapshot.url !== attempt.beforeUrl) {
        model.successfulKey = attempt.key;
        model.restored = null;
        model.observedUrl = snapshot.url;
        model.previewMismatch = false;
        model.attempt = null;
        model.error = '';
        return 'success';
      }
      return null;
    };
    model.clear = function () {
      if (model.attempt) model.unsettled = model.attempt;
      model.file = null;
      model.revision += 1;
      model.successfulKey = null;
      model.attempt = null;
      model.error = '';
      model.observedUrl = '';
      model.previewMismatch = false;
      model.restored = null;
      // A late native result after removing a photo must not validate that
      // removed source. Only a fresh upload/generation can clear this guard.
      model.photoWasCleared = true;
    };
    return model;
  }

  if (!win || !win.document) return {
    createModel: createModel, parseLabels: parseLabels, escape: escape,
    resolveRequestedText: resolveRequestedText,
    createSourceCache: createSourceCache,
    DEFAULT_TEXT: DEFAULT_TEXT, TIMEOUT_MS: TIMEOUT_MS, SOURCE_TTL_MS: SOURCE_TTL_MS,
    SOURCE_MAX_BYTES: SOURCE_MAX_BYTES, SOURCE_CACHE_MAX_BYTES: SOURCE_CACHE_MAX_BYTES,
    SOURCE_CACHE_MAX_RECORDS: SOURCE_CACHE_MAX_RECORDS
  };
  var doc = win.document;
  var instances = new WeakMap();
  var sourceCache = createSourceCache(win);

  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function attr(node, name, value) { if (node && node.getAttribute(name) !== value) node.setAttribute(name, value); }
  function setValue(control, value) {
    if (!control || control.value === value) return;
    control.value = value;
    control.dispatchEvent(new win.Event('input', { bubbles: true }));
    control.dispatchEvent(new win.Event('change', { bubbles: true }));
  }
  function safeLayer(value) { return /^layer-\d+$/.test(value || '') ? value : ''; }

  function mount(root) {
    if (instances.has(root)) return;
    var photoId = safeLayer(root.getAttribute('data-tp-custom-changes-photo'));
    var textId = safeLayer(root.getAttribute('data-tp-custom-changes-text'));
    if (!photoId || !textId) return;
    var contextIds = String(root.getAttribute('data-tp-custom-changes-context') || '').split(',')
      .map(function (id) { return safeLayer(id.trim()); })
      .filter(function (id, index, ids) { return id && id !== photoId && id !== textId && ids.indexOf(id) === index; });
    var labelsScript = root.querySelector('script[data-tp-custom-changes-labels]');
    var labels = parseLabels(labelsScript && labelsScript.textContent);

    var model = createModel();
    var replaying = false;
    var panel = null;
    var cartStatus = null;
    var enabled = false;
    var editorValue = '';
    var mounted = false;
    var timer = null;
    var ticker = null;
    var nativeBusy = false;
    var galleryUrl = '';
    var removalConfirmation = null;
    var removalRequest = null;
    var pendingHistoryDisplayUrl = '';
    var cartAttempted = false;
    var nativeStaleNeedsRegeneration = false;
    var nativeRestoredProject = null;
    var pristine = true;
    var restorationAllowed = true;
    var writingNative = false;
    // Teeinblue remembers global-option values across products. Keep this
    // optional editor local to this product/tab; photo bytes never enter Web Storage.
    var draftKey = 'tp-cc-draft-v1:' + doc.location.pathname + ':' + photoId + ':' + textId;
    var localDraft = null;
    try {
      var savedDraft = JSON.parse(win.sessionStorage.getItem(draftKey) || 'null');
      if (savedDraft && typeof savedDraft.enabled === 'boolean' &&
          typeof savedDraft.text === 'string' && savedDraft.text.length <= 500) localDraft = savedDraft;
    } catch (_error) { /* Storage may be disabled. Native validation still applies. */ }
    var draftWasRestored = !!localDraft;
    var sourceRecoveryPending = false;
    var recoveredOriginal = null;
    var recoveredUrl = '';
    var recoveredExpires = 0;
    var recoveryRecord = null;
    var recoveredReceipt = null;
    var receiptPresent = false;
    var sourcePathname = doc.location.pathname;
    var sourceSessionId = '';
    var sourceEpoch = 0;
    var sourceId = '';
    var sourceKey = '';
    var sourceMarkerKey = '';
    function newSourceId() {
      if (win.crypto && typeof win.crypto.randomUUID === 'function') return win.crypto.randomUUID();
      return String(Date.now()) + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    }
    try {
      var sessionKey = 'tp-cc-source-session-v1';
      var sessionId = win.sessionStorage.getItem(sessionKey);
      if (!/^[a-zA-Z0-9_-]{10,80}$/.test(sessionId || '')) {
        sessionId = newSourceId();
        win.sessionStorage.setItem(sessionKey, sessionId);
      }
      sourceSessionId = sessionId;
      sourceKey = JSON.stringify(['v1', sessionId, doc.location.pathname, photoId, textId, contextIds]);
      sourceMarkerKey = 'tp-cc-source-current-v1:' + sourceKey;
      sourceId = win.sessionStorage.getItem(sourceMarkerKey) || '';
    } catch (_error) { sourceKey = ''; /* Memory-only replay remains available. */ }
    if (sourceKey && sourceId && sourceId.indexOf('cleared-') !== 0) {
      var loadEpoch = sourceEpoch;
      sourceRecoveryPending = true;
      sourceCache.get(sourceKey).then(function (record) {
        sourceRecoveryPending = false;
        if (!root.isConnected) return;
        if (loadEpoch === sourceEpoch && record && record.sourceId === sourceId) {
          recoveryRecord = record;
          receiptPresent = !!record.acceptedRequest;
        }
        schedule();
      });
    }
    var state = { model: model };
    instances.set(root, state);

    function photoField() { return root.querySelector('.tee-field--' + photoId); }
    function nativeTextField() { return root.querySelector('.tee-field--' + textId); }
    function nativeTextControl() {
      var field = nativeTextField();
      return field && field.querySelector('textarea, input[type="text"], input:not([type])');
    }
    function nativePhotoInput() {
      var field = photoField();
      return field && field.querySelector('input[type="file"]');
    }
    function invalidateOriginal(cleared) {
      sourceEpoch += 1;
      sourceRecoveryPending = false;
      recoveredOriginal = null;
      recoveredUrl = '';
      recoveredExpires = 0;
      recoveryRecord = null;
      recoveredReceipt = null;
      receiptPresent = false;
      sourceId = (cleared ? 'cleared-' : '') + newSourceId();
      if (!sourceKey) return;
      var previousKey = sourceKey;
      // The small immediate marker also rejects a late queued write/read if a
      // reload happens before the IndexedDB deletion finishes.
      try { win.sessionStorage.setItem(sourceMarkerKey, sourceId); }
      catch (_error) { sourceKey = ''; }
      sourceCache.remove(previousKey);
    }
    function recoverOriginal(current) {
      if (!recoveryRecord || recoveredOriginal || model.file || model.revision || model.photoWasCleared ||
          !current || !current.uploaded || current.busy || current.url !== recoveryRecord.processedUrl ||
          recoveryRecord.sourceId !== sourceId || recoveryRecord.expiresAt <= Date.now()) return;
      try {
        recoveredOriginal = new win.File([recoveryRecord.blob], recoveryRecord.name,
          { type: recoveryRecord.type, lastModified: recoveryRecord.lastModified });
        recoveredUrl = recoveryRecord.processedUrl;
        recoveredExpires = recoveryRecord.expiresAt;
        receiptPresent = !!recoveryRecord.acceptedRequest;
        recoveredReceipt = acceptedReceipt(recoveryRecord);
      } catch (_error) { /* Keep the explicit original-upload fallback. */ }
      recoveryRecord = null;
    }
    function availableSource() {
      if (model.file) return model.file;
      var current = snapshot();
      return recoveredOriginal && !model.photoWasCleared && Date.now() < recoveredExpires &&
        current && current.uploaded && current.url === recoveredUrl ? recoveredOriginal : null;
    }
    function rememberSuccessfulOriginal() {
      if (!sourceKey || !model.file || !model.successfulKey || !model.observedUrl || !sourceId) return;
      // A prior request can finish after a different File was selected during
      // its busy phase. That late image must never be bound to the newer File.
      var accepted = JSON.parse(model.successfulKey);
      if (accepted[0] !== model.revision) return;
      var savedKey = model.successfulKey;
      var savedFile = model.file;
      var savedUrl = model.observedUrl;
      var receipt = { version: 1, scope: sourceKey, sourceId: sourceId, processedUrl: savedUrl,
        requestText: accepted[1], context: accepted[2] };
      var savedEpoch = sourceEpoch;
      var savedId = sourceId;
      sourceCache.save(sourceKey, savedId, savedFile, savedUrl, function () {
        return root.isConnected && savedEpoch === sourceEpoch && savedId === sourceId && !model.photoWasCleared &&
          model.file === savedFile && model.successfulKey === savedKey && model.observedUrl === savedUrl;
      }, receipt);
    }
    function generationContext() {
      var controls = [];
      var identity = [];
      var valid = true;
      contextIds.forEach(function (id) {
        var field = root.querySelector('.tee-field--' + id);
        if (!field) { identity.push([id, null]); valid = false; return; }
        var fields = Array.prototype.slice.call(field.querySelectorAll('input:not([type="file"]), textarea, select'));
        if (!fields.length) { identity.push([id, null]); valid = false; return; }
        fields.forEach(function (control) { if (controls.indexOf(control) === -1) controls.push(control); });
      });
      // Production birthdays already carry this class. Exact context IDs also
      // support other prompt variables without treating captions/frame as AI edits.
      root.querySelectorAll('.tp-birthday-age input[type="number"], input.tp-birthday-age[type="number"]').forEach(function (control) {
        if (controls.indexOf(control) === -1) controls.push(control);
      });
      controls.forEach(function (control, index) {
        if (control.disabled) return;
        var id = control.id || control.name || String(index);
        var value = (control.type === 'radio' || control.type === 'checkbox') ?
          (control.checked ? control.value : '') : control.value;
        identity.push([id, String(value == null ? '' : value)]);
        if ((control.validity && !control.validity.valid) ||
            (control.closest('.tp-birthday-age') && !/^[1-9]\d?$/.test(String(control.value)))) valid = false;
      });
      return { identity: JSON.stringify(identity), valid: valid, controls: controls };
    }
    function hydrateNative() {
      if (!pristine || model.file || model.pending() || model.unsettled) return;
      var control = nativeTextControl();
      if (!control) return;
      var value = String(control.value || '').trim();
      var currentPhoto = snapshot();
      if (!nativeRestoredProject && currentPhoto && currentPhoto.uploaded &&
          currentPhoto.url && !currentPhoto.busy) {
        // Read the SDK's saved instruction before a local draft can overwrite it.
        // This preserves text only; native/model/receipt checks still own approval.
        nativeRestoredProject = { text: value || DEFAULT_TEXT, url: currentPhoto.url };
      }
      if (localDraft) {
        enabled = localDraft.enabled;
        editorValue = localDraft.text;
        return;
      }
      if (!currentPhoto || (!currentPhoto.uploaded && !currentPhoto.busy)) {
        // A different product's remembered global value is not an instruction
        // for an empty new project. Existing uploaded projects are read below.
        enabled = false;
        editorValue = '';
        return;
      }
      // Read before writing: native saved projects may contain an existing custom
      // instruction even though the browser cannot restore the original File.
      enabled = !!value && value !== DEFAULT_TEXT;
      editorValue = enabled ? value : '';
    }
    function rememberDraft() {
      localDraft = { enabled: enabled, text: editorValue };
      try { win.sessionStorage.setItem(draftKey, JSON.stringify(localDraft)); }
      catch (_error) { /* Keep the same-tab in-memory draft when storage is blocked. */ }
    }
    function syncPhotoCopy() {
      var field = photoField();
      if (!field) return;
      // Keep native validation intact. This prompt-change hint is redundant
      // while the customer edits their changes; actual upload errors stay visible.
      field.querySelectorAll('.tee-photo-error').forEach(function (warning) {
        var value = warning.textContent.trim().replace(/^\*\s*/, '');
        var detailsChanged = isPhotoDetailsChanged(value, labels.photoDetailsChanged);
        if (value === 'Your details changed after this photo was processed. Please upload it again.') {
          text(warning, labels.photoDetailsChanged);
        }
        attr(warning, 'data-tp-cc-silent-warning', enabled && detailsChanged ? 'true' : 'false');
      });
      var photo = field.querySelector('.tee-photo');
      var label = field.querySelector('.tee-photo-label');
      var input = nativePhotoInput();
      if (!photo || !label || !input) return;
      var ready = !!label.querySelector('.tee-photo-uploaded') && !field.querySelector('.tee-photo-uploading');
      attr(photo, 'data-tp-cc-photo-ready', ready ? 'true' : 'false');
      var caption = label.querySelector('[data-tp-cc-photo-caption]');
      if (ready && !caption) {
        caption = doc.createElement('span');
        caption.className = 'tp-cc-photo-caption';
        attr(caption, 'data-tp-cc-photo-caption', 'true');
        label.appendChild(caption);
      }
      if (caption) { text(caption, labels.chooseAnotherPhoto); caption.hidden = !ready; }
      if (ready) {
        // The original label still activates the original file input. Keep
        // the thumbnail DOM/src for native history and generation validation.
        attr(label, 'role', 'button');
        attr(label, 'tabindex', '0');
        attr(label, 'aria-label', labels.chooseAnotherPhoto);
        if (!label.hasAttribute('data-tp-cc-photo-keyboard')) {
          attr(label, 'data-tp-cc-photo-keyboard', 'true');
          label.addEventListener('click', function (event) {
            if (photo.getAttribute('data-tp-cc-photo-ready') !== 'true' ||
                (event.target.closest && event.target.closest('.tee-photo-clear'))) return;
            // Activate synchronously from the user's click, rather than relying
            // on default label activation through the SDK's nested controls.
            event.preventDefault();
            var currentInput = nativePhotoInput();
            if (currentInput && !currentInput.disabled) currentInput.click();
          });
          label.addEventListener('keydown', function (event) {
            if (event.target !== label || (event.key !== 'Enter' && event.key !== ' ')) return;
            event.preventDefault();
            var currentInput = nativePhotoInput();
            if (currentInput && !currentInput.disabled) currentInput.click();
          });
        }
        var clear = label.querySelector('.tee-photo-clear');
        if (clear) attr(clear, 'aria-label', labels.removePhoto);
      } else if (label.hasAttribute('data-tp-cc-photo-keyboard')) {
        label.removeAttribute('role');
        label.removeAttribute('tabindex');
        label.removeAttribute('aria-label');
      }
    }
    function snapshot() {
      var field = photoField();
      if (!field) return null;
      var uploaded = field.querySelector('.tee-photo-uploaded');
      var image = field.querySelector('.tee-photo-uploaded img, img.tee-photo-image');
      var errors = Array.prototype.slice.call(field.querySelectorAll('.tee-photo-error, .tee-upload-error, .tee-error-message, .tee-error'))
        .map(function (error) {
          var value = String(error.textContent || '').trim().replace(/^\*\s*/, '').replace(/\s+/g, ' ');
          // Translation of the native stale hint changes presentation, not its
          // failure identity, including when a native text node is restored.
          return isPhotoDetailsChanged(value, labels.photoDetailsChanged) ? 'photo-details-changed' : value;
        }).filter(function (value, index, values) { return value && values.indexOf(value) === index; }).sort();
      return {
        busy: !!field.querySelector('.tee-photo-uploading'),
        uploaded: !!uploaded,
        url: image && (image.currentSrc || image.getAttribute('src')) || '',
        error: !!errors.length,
        errorKey: errors.length ? JSON.stringify(errors) : '',
        generationErrorKey: JSON.stringify(errors.filter(function (value) { return value !== 'photo-details-changed'; })) === '[]'
          ? '' : JSON.stringify(errors.filter(function (value) { return value !== 'photo-details-changed'; }))
      };
    }
    function syncCurrentPreview() {
      var field = photoField();
      var head = field && field.querySelector('.tee-photo-head');
      if (!head) return;
      var preview = head.querySelector('[data-tp-cc-current-preview]');
      var fallback = head.querySelector('[data-tp-cc-photo-results]');
      var history = head.querySelector('.tee-photo-preview-history');
      // Keep our current tile separate from selectable SDK history entries.
      // Hide its native duplicate without moving native nodes/handlers or nesting
      // a remove button inside a potentially interactive SDK history element.
      if (history) history.querySelectorAll('.tee-photo-preview-history__item').forEach(function (item) {
        var image = item.querySelector('img');
        var current = !!galleryUrl && image && (image.currentSrc || image.getAttribute('src') || '') === galleryUrl;
        attr(item, 'data-tp-cc-current-history', current ? 'true' : 'false');
      });
      if (!galleryUrl) {
        if (preview) preview.remove();
        if (fallback) fallback.remove();
        return;
      }
      var target = history || fallback;
      if (!target) {
        target = doc.createElement('div');
        target.className = 'tp-cc-photo-results';
        attr(target, 'data-tp-cc-photo-results', 'true');
        head.appendChild(target);
      }
      if (!preview) {
        preview = doc.createElement('div');
        preview.className = 'tp-cc-current-preview';
        attr(preview, 'data-tp-cc-current-preview', 'true');
        var image = doc.createElement('img');
        image.className = 'tp-cc-current-preview__image';
        attr(image, 'width', '58');
        attr(image, 'height', '84');
        preview.appendChild(image);
        var remove = doc.createElement('button');
        remove.type = 'button';
        remove.className = 'tp-cc-photo-remove';
        attr(remove, 'data-tp-cc-photo-remove', 'true');
        attr(remove, 'aria-label', labels.removePhoto);
        attr(remove, 'title', labels.removePhoto);
        remove.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>';
        preview.appendChild(remove);
      }
      // Preserve native nodes, handlers and metadata; only our own tile moves
      // when the SDK creates/replaces its history container.
      if (preview.parentNode !== target) target.insertBefore(preview, target.firstChild);
      attr(preview, 'title', labels.currentProject);
      var currentImage = preview.querySelector('img');
      attr(currentImage, 'alt', labels.currentProject);
      attr(currentImage, 'src', galleryUrl);
      if (fallback && fallback !== target) fallback.remove();
    }
    function canRemovePhoto(current) {
      return !!(galleryUrl && current && current.uploaded && current.url === galleryUrl &&
        !current.busy && !model.pending() && !model.unsettled && !model.photoWasCleared);
    }
    function closeRemovalConfirmation(restoreFocus) {
      var trigger = removalRequest && removalRequest.trigger;
      removalRequest = null;
      if (removalConfirmation) removalConfirmation.hidden = true;
      if (restoreFocus && trigger && trigger.isConnected && !trigger.hidden) trigger.focus();
    }
    function syncPhotoRemoval() {
      var field = photoField();
      if (!field) return;
      var current = snapshot();
      var allowed = canRemovePhoto(current) && !!field.querySelector('.tee-photo-clear');
      // A changed source/history selection must never be deleted by an old question.
      if (removalRequest && (!allowed || removalRequest.url !== galleryUrl || removalRequest.epoch !== sourceEpoch ||
          !removalConfirmation || !removalConfirmation.isConnected || !field.contains(removalConfirmation))) {
        closeRemovalConfirmation(false);
      }
      field.querySelectorAll('[data-tp-cc-photo-remove]').forEach(function (button) {
        button.hidden = !allowed;
        button.disabled = !allowed;
        attr(button, 'aria-expanded', removalRequest ? 'true' : 'false');
      });
    }
    function openRemovalConfirmation(trigger) {
      var field = photoField();
      var confirmationHost = field && (field.querySelector('.tee-field__input') || field.querySelector('.tee-photo'));
      if (!confirmationHost || !canRemovePhoto(snapshot()) || !field.querySelector('.tee-photo-clear')) return;
      if (!removalConfirmation || !removalConfirmation.isConnected) {
        removalConfirmation = doc.createElement('div');
        removalConfirmation.className = 'tp-cc-photo-remove-confirm';
        removalConfirmation.id = 'tp-cc-photo-remove-confirm-' + root.id;
        attr(removalConfirmation, 'data-tp-cc-photo-remove-confirm', 'true');
        attr(removalConfirmation, 'role', 'group');
        var question = doc.createElement('p');
        question.id = 'tp-cc-photo-remove-question-' + root.id;
        text(question, labels.confirmRemovePhoto);
        attr(removalConfirmation, 'aria-labelledby', question.id);
        removalConfirmation.appendChild(question);
        var actions = doc.createElement('div');
        actions.className = 'tp-cc-photo-remove-confirm__actions';
        [['confirm', labels.deletePhoto], ['cancel', labels.keepPhoto]].forEach(function (choice) {
          var button = doc.createElement('button');
          button.type = 'button';
          attr(button, 'data-tp-cc-photo-remove-action', choice[0]);
          text(button, choice[1]);
          actions.appendChild(button);
        });
        removalConfirmation.appendChild(actions);
        // The guided-step controller owns hidden on direct field children.
        // Nest the question inside its body so reopening a step cannot undo cancel.
        confirmationHost.appendChild(removalConfirmation);
      }
      removalRequest = { url: galleryUrl, epoch: sourceEpoch, trigger: trigger };
      removalConfirmation.hidden = false;
      attr(trigger, 'aria-controls', removalConfirmation.id);
      syncPhotoRemoval();
      // Safe default; Escape and Zostaw both leave all project/source state intact.
      removalConfirmation.querySelector('[data-tp-cc-photo-remove-action="cancel"]').focus();
    }
    function confirmPhotoRemoval() {
      var request = removalRequest;
      var field = photoField();
      var clear = field && field.querySelector('.tee-photo-clear');
      if (!request || !clear || clear.disabled || !canRemovePhoto(snapshot()) ||
          request.url !== galleryUrl || request.epoch !== sourceEpoch) {
        closeRemovalConfirmation(true);
        return;
      }
      closeRemovalConfirmation(false);
      enabled = false;
      editorValue = '';
      draftWasRestored = false;
      rememberDraft();
      // The existing native-clear capture invalidates IndexedDB, model and gallery.
      // Teeinblue owns clearing its photo, SDK metadata and persisted selection.
      clear.click();
      syncWanted();
      render();
      var input = nativePhotoInput();
      var currentField = photoField();
      var chooser = currentField && currentField.querySelector('.tee-photo-action .tee-btn--upload');
      if (chooser && input && !input.disabled) chooser.focus();
    }
    function requestHistoryDisplay(item) {
      var image = item && item.querySelector('img');
      pendingHistoryDisplayUrl = image && (image.currentSrc || image.getAttribute('src')) || '';
      // The SDK owns selection and its metadata. Wait for the native photo DOM
      // to confirm this exact URL; the click alone grants no display approval.
      schedule();
    }
    function acceptedProjectText() {
      // Closing the editor discards a draft, not the already generated project.
      // Reuse an existing request identity; never create approval from a toggle.
      if (!model.photoWasCleared) {
        var acceptedKey = model.successfulKey || (model.restored && model.restored.key);
        if (acceptedKey) {
          var accepted = JSON.parse(acceptedKey);
          if (accepted[0] === model.revision) return accepted[1];
        }
        var current = snapshot();
        if (!model.file && !model.revision && nativeRestoredProject && current &&
            current.uploaded && current.url === nativeRestoredProject.url) {
          return nativeRestoredProject.text;
        }
      }
      return DEFAULT_TEXT;
    }
    function syncWanted() {
      model.setText(enabled ? resolveRequestedText(true, editorValue) : acceptedProjectText(),
        !enabled || editorValue.length <= 500);
      var context = generationContext();
      model.setContext(context.identity, context.valid);
      // SDK restoration can populate the photo after its native text control.
      // Keep that saved instruction intact while the new optional UI is empty;
      // the first File/editor/cart action still writes our resolved instruction
      // synchronously before Teeinblue consumes it.
      var currentPhoto = snapshot();
      var awaitingNativeRestore = pristine && !localDraft && !model.file &&
        (!currentPhoto || (!currentPhoto.uploaded && !currentPhoto.busy));
      // Do not change the native prompt while an asynchronous request is consuming it.
      var awaitingReceipt = sourceRecoveryPending && !model.file && !model.revision;
      if (!model.pending() && !model.unsettled && !awaitingNativeRestore && !awaitingReceipt) {
        writingNative = true;
        try { setValue(nativeTextControl(), model.requestedText); } finally { writingNative = false; }
      }
    }
    function ensurePanel() {
      var field = nativeTextField();
      var control = nativeTextControl();
      if (!field || !control || !photoField()) return false;
      var uploadButton = photoField().querySelector('label.tee-btn--upload');
      if (uploadButton) { attr(uploadButton, 'role', 'button'); attr(uploadButton, 'aria-label', labels.uploadPhoto); }
      attr(field, 'data-tp-cc-native', 'true');
      // The existing theme excludes sr-only fields from guided steps. Leave the
      // native control enabled and populated for Teeinblue's prompt variable.
      if (!field.classList.contains('sr-only')) field.classList.add('sr-only');
      attr(control, 'tabindex', '-1');
      if (!panel) {
        panel = doc.createElement('div');
        panel.className = 'tp-custom-changes';
        var suffix = String(root.id || photoId).replace(/[^a-zA-Z0-9_-]/g, '');
        panel.innerHTML =
          '<label class="tp-custom-changes__choice"><input type="checkbox" data-tp-cc-enabled aria-controls="tp-cc-body-' + suffix + '" aria-expanded="false"><span>' + escape(labels.choice) + '</span></label>' +
          '<div id="tp-cc-body-' + suffix + '" class="tp-custom-changes__body" hidden>' +
            '<label class="tp-custom-changes__label" for="tp-cc-text-' + suffix + '">' + escape(labels.editorLabel) + '</label>' +
            '<textarea id="tp-cc-text-' + suffix + '" class="tp-custom-changes__text" maxlength="500" rows="3" aria-required="false" disabled ' +
              'placeholder="' + escape(labels.placeholder) + '"></textarea>' +
          '</div>' +
          '<button type="button" class="tp-custom-changes__button" data-tp-cc-regenerate hidden>' + escape(labels.regenerate) + '</button>' +
          '<p class="tp-custom-changes__status" data-tp-cc-status role="status" aria-live="polite" aria-atomic="true" hidden></p>';
        panel.querySelector('[data-tp-cc-enabled]').addEventListener('change', function (event) {
          pristine = false;
          enabled = event.target.checked;
          rememberDraft();
          cartAttempted = false;
          syncWanted();
          syncPhotoCopy();
          render();
          if (enabled) panel.querySelector('textarea').focus();
        });
        panel.querySelector('textarea').addEventListener('input', function (event) {
          pristine = false;
          editorValue = event.target.value;
          rememberDraft();
          cartAttempted = false;
          syncWanted();
          syncPhotoCopy();
          render();
        });
        panel.querySelector('[data-tp-cc-regenerate]').addEventListener('click', regenerate);
        // Editing this optional description is not completion of the photo step.
        // Keep the guided form from advancing when its nested controls change.
        ['change', 'input'].forEach(function (type) {
          panel.addEventListener(type, function (event) { event.stopPropagation(); });
        });
      }
      // Keep the same editor inside the photo step, beside native crop controls.
      // Never move the native button or put the editor inside the upload label.
      var anchor = photoField();
      var actions = anchor.querySelector('.tee-photo-action');
      var mount = actions || anchor.querySelector('.tee-field__input') || anchor;
      if (actions && !actions.classList.contains('tp-cc-photo-actions')) actions.classList.add('tp-cc-photo-actions');
      panel.classList.toggle('tp-custom-changes--in-photo', !!actions);
      // A native field replacement can include a DOM clone without listeners.
      // Restore our original panel and remove only its disconnected replacement.
      root.querySelectorAll('.tp-custom-changes').forEach(function (copy) {
        if (copy !== panel) copy.remove();
      });
      if (panel.parentElement !== mount) mount.appendChild(panel);
      mounted = true;
      return true;
    }
    function ensureCartStatus() {
      var action = root.querySelector(ATC_SELECTOR);
      if (!action) return;
      if (!cartStatus) {
        cartStatus = doc.createElement('p');
        cartStatus.className = 'tp-cc-cart-status';
        cartStatus.setAttribute('data-tp-cc-cart-status', '');
        cartStatus.setAttribute('role', 'status');
        cartStatus.setAttribute('aria-live', 'polite');
        cartStatus.setAttribute('aria-atomic', 'true');
        cartStatus.setAttribute('tabindex', '-1');
        cartStatus.hidden = true;
      }
      var anchor = action.closest('.tee-form-action') || action;
      if (!cartStatus.isConnected || cartStatus.nextElementSibling !== anchor) anchor.insertAdjacentElement('beforebegin', cartStatus);
    }
    function matchesAcceptedReceipt(current) {
      if (!recoveredReceipt || !recoveredOriginal || sourceRecoveryPending || !restorationAllowed ||
          model.file || model.revision || model.successfulKey !== null || model.pending() || model.unsettled ||
          model.error || model.photoWasCleared || !model.validText || !model.validContext ||
          (enabled && !editorValue.trim()) || Date.now() >= recoveredExpires || doc.location.pathname !== sourcePathname ||
          safeLayer(root.getAttribute('data-tp-custom-changes-photo')) !== photoId ||
          safeLayer(root.getAttribute('data-tp-custom-changes-text')) !== textId ||
          !current || !current.uploaded || current.busy || current.url !== recoveredUrl ||
          (current.error && current.errorKey !== JSON.stringify(['photo-details-changed'])) ||
          recoveredReceipt.scope !== sourceKey || recoveredReceipt.sourceId !== sourceId ||
          recoveredReceipt.processedUrl !== current.url || recoveredReceipt.requestText !== model.requestedText ||
          recoveredReceipt.context !== model.context) return false;
      var currentContextIds = String(root.getAttribute('data-tp-custom-changes-context') || '').split(',')
        .map(function (id) { return safeLayer(id.trim()); })
        .filter(function (id, index, ids) { return id && id !== photoId && id !== textId && ids.indexOf(id) === index; });
      if (JSON.stringify(currentContextIds) !== JSON.stringify(contextIds)) return false;
      try { return win.sessionStorage.getItem('tp-cc-source-session-v1') === sourceSessionId &&
        win.sessionStorage.getItem(sourceMarkerKey) === sourceId; }
      catch (_error) { return false; }
    }
    function trackNativeStale(current) {
      if (matchesAcceptedReceipt(current)) {
        // This is proof of an earlier accepted request, never a new success.
        // The native DOM and its own cart validation remain untouched.
        nativeStaleNeedsRegeneration = false;
        return true;
      }
      var acceptedKey = model.successfulKey || (model.restored && model.restored.key);
      var acceptedUrl = model.successfulKey ? model.observedUrl : model.restored && model.restored.url;
      var control = nativeTextControl();
      // Teeinblue clears its details warning after the original prompt returns.
      // Clear only our sticky hint, and only for that exact approved request.
      // Age, source/history changes, failures and in-flight requests stay guarded.
      if (!enabled && restorationAllowed && !sourceRecoveryPending &&
          !model.pending() && !model.unsettled && !model.error && !model.photoWasCleared &&
          model.validText && model.validContext && acceptedKey === model.key() &&
          current && current.uploaded && !current.busy && !current.error &&
          current.url && current.url === acceptedUrl &&
          control && control.value === model.requestedText) {
        nativeStaleNeedsRegeneration = false;
        return false;
      }
      if (current && current.uploaded && current.url &&
          (current.errorKey === JSON.stringify(['photo-details-changed']) ||
           receiptPresent)) nativeStaleNeedsRegeneration = true;
      return false;
    }
    function cartBlocked() {
      var current = snapshot();
      return nativeStaleNeedsRegeneration || model.blocked() ||
        (sourceRecoveryPending && current && current.uploaded && !!current.url);
    }
    function observeProject(current) {
      recoverOriginal(current);
      var acceptedRestore = trackNativeStale(current);
      if (acceptedRestore) {
        // Only our restored-request view ignores the SDK's details-only hint.
        // Attempts cannot enter this branch, so it cannot manufacture success.
        current = Object.assign({}, current, { error: false, errorKey: '', generationErrorKey: '' });
        model.restore(current);
      }
      var observed = model.observe(current);
      if (observed === 'success') {
        nativeStaleNeedsRegeneration = false;
        if (!enabled) syncWanted();
        rememberSuccessfulOriginal();
      }
      return observed;
    }
    function message() {
      if (sourceRecoveryPending && snapshot() && snapshot().uploaded) return 'Przywracamy zapisany projekt. Spróbuj ponownie za chwilę.';
      if (model.unsettled) return labels.waitingForPrevious;
      if (model.pending()) return nativeBusy || (model.attempt && model.attempt.sawBusy)
        ? labels.waitGeneration : labels.confirmCrop;
      if (model.error === 'unsupported') return labels.browserRetry;
      if (model.error === 'timeout') return labels.timeout;
      if (model.error) return labels.generationError;
      if (!availableSource()) return enabled || cartBlocked() ? (galleryUrl ? labels.uploadAgain : labels.uploadFirst) : '';
      if (enabled && !editorValue.trim()) return '';
      if (cartBlocked()) return cartAttempted && enabled ? labels.regenerateBeforeCart : '';
      return '';
    }
    function render() {
      var current = snapshot();
      trackNativeStale(current);
      // A native upload marker or history thumbnail alone is not an AI result.
      // Publish only the completed request's image, for this source revision.
      var completed = model.successfulKey !== null && !model.pending() && !model.unsettled && !model.error &&
        !model.photoWasCleared && JSON.parse(model.successfulKey)[0] === model.revision &&
        current && current.uploaded && !current.busy && !current.error && current.url === model.observedUrl;
      var generated = completed && model.successfulKey === model.key() && !nativeStaleNeedsRegeneration;
      attr(root, 'data-tp-cc-generated-url', generated ? model.observedUrl : '');
      // Display approval is separate from cart approval: keep the last successful
      // customer artwork through editing/retries. After a page reload the SDK's
      // processed upload can restore display only; it never validates our model.
      if (model.photoWasCleared) { galleryUrl = ''; pendingHistoryDisplayUrl = ''; }
      else if (pendingHistoryDisplayUrl && !model.pending() && !model.unsettled &&
          current && current.uploaded && !current.busy && !generationErrorKey(current) &&
          current.url === pendingHistoryDisplayUrl) {
        // An explicit native history selection may change presentation only.
        // It never changes the accepted request, generated proof or cart guard.
        galleryUrl = current.url;
        pendingHistoryDisplayUrl = '';
      }
      else if (completed) galleryUrl = model.observedUrl;
      else if (!galleryUrl && model.revision === 0 && !model.file && !model.pending() && !model.unsettled &&
          current && current.uploaded && current.url && !current.busy && !generationErrorKey(current)) galleryUrl = current.url;
      attr(root, 'data-tp-cc-gallery-url', galleryUrl);
      // Diagnostics expose state only; never photo bytes, storage keys or customer text.
      attr(root, 'data-tp-cc-draft-restored', draftWasRestored ? 'true' : 'false');
      attr(root, 'data-tp-cc-accepted-request', matchesAcceptedReceipt(current) ? 'matched' : receiptPresent ? 'mismatch' : 'missing');
      attr(root, 'data-tp-cc-source-status', availableSource() ? 'available' : sourceRecoveryPending ? 'loading' : 'missing');
      syncCurrentPreview();
      syncPhotoRemoval();
      if (!panel || !mounted) return;
      panel.hidden = !galleryUrl;
      var textarea = panel.querySelector('textarea');
      var button = panel.querySelector('[data-tp-cc-regenerate]');
      var status = panel.querySelector('[data-tp-cc-status]');
      var choice = panel.querySelector('[data-tp-cc-enabled]');
      choice.checked = enabled;
      if (textarea.value !== editorValue) textarea.value = editorValue;
      panel.querySelector('.tp-custom-changes__body').hidden = !enabled;
      attr(choice, 'aria-expanded', enabled ? 'true' : 'false');
      textarea.disabled = !enabled;
      button.disabled = !availableSource() || (enabled && !editorValue.trim()) || !model.validText || !model.validContext || model.pending() || !!model.unsettled || nativeBusy;
      button.hidden = !enabled;
      text(button, model.pending() ? labels.generating : enabled ? labels.regenerate : labels.regenerateDefault);
      var statusMessage = message();
      text(status, statusMessage);
      status.hidden = !statusMessage;
      attr(panel, 'data-tp-cc-state', model.pending() ? 'pending' : model.error ? 'error' : cartBlocked() ? 'stale' : 'ready');
      attr(panel, 'aria-busy', model.pending() || model.unsettled ? 'true' : 'false');
      // Never set disabled=false or remove native validation from Teeinblue ATC.
      attr(root, 'data-tp-cc-cart-guard', cartBlocked() ? 'blocked' : 'native');
      ensureCartStatus();
      if (cartStatus) {
        // Cart feedback must remain visible before the first result, when the
        // optional editor is hidden. Do not show stale notices while typing.
        var feedback = cartAttempted || model.pending() || model.unsettled || model.error
          ? statusMessage : '';
        text(cartStatus, feedback);
        cartStatus.hidden = !feedback;
        attr(cartStatus, 'data-tp-state', model.error ? 'error' : 'waiting');
      }
    }
    function ensureTicker() {
      var waiting = model.pending() || !!model.unsettled;
      if (waiting && !ticker) ticker = win.setInterval(refresh, 1000);
      if (!waiting && ticker) { win.clearInterval(ticker); ticker = null; }
    }
    function refresh() {
      if (!root.isConnected) {
        observer.disconnect();
        if (ticker) win.clearInterval(ticker);
        return;
      }
      var current = snapshot();
      nativeBusy = !!(current && current.busy);
      hydrateNative();
      recoverOriginal(current);
      if (pristine && restorationAllowed && !sourceRecoveryPending && !receiptPresent &&
          nativeRestoredProject && current && current.url === nativeRestoredProject.url) {
        // Pin the saved native request before applying a still-unsubmitted draft.
        // model.restore rejects busy/error/missing photos and never starts AI.
        model.setText(nativeRestoredProject.text, true);
        var restoredContext = generationContext();
        model.setContext(restoredContext.identity, restoredContext.valid);
        model.restore(current);
      }
      syncWanted();
      observeProject(current);
      syncPhotoCopy();
      if (!ensurePanel()) { ensureTicker(); return; }
      syncWanted();
      render();
      ensureTicker();
    }
    function schedule() {
      if (timer) return;
      timer = win.setTimeout(function () { timer = null; refresh(); }, 40);
    }
    function begin() {
      var epoch = model.begin(snapshot());
      if (epoch === null) return null;
      pendingHistoryDisplayUrl = '';
      render();
      ensureTicker();
      return epoch;
    }
    function regenerate() {
      cartAttempted = false;
      pristine = false;
      syncWanted();
      if (enabled && !editorValue.trim()) { render(); return; }
      // The native birthday guard intercepts file changes at window capture.
      // Validate first so an invalid age cannot create an attempt that never runs.
      if (!model.validContext) {
        generationContext().controls.some(function (control) {
          if (!control.disabled && ((control.validity && !control.validity.valid) ||
              (control.closest('.tp-birthday-age') && !/^[1-9]\d?$/.test(String(control.value))))) {
            control.focus();
            if (control.reportValidity) control.reportValidity();
            return true;
          }
          return false;
        });
        render();
        return;
      }
      var input = nativePhotoInput();
      if (!input || input.disabled || nativeBusy) return;
      var original = availableSource();
      if (!model.file && original) {
        // Recovery grants a source for this explicit action, never approval of
        // the restored preview or an automatic paid/native upload on page load.
        sourceEpoch += 1;
        model.setSource(original);
        recoveredOriginal = null;
        recoveredUrl = '';
        recoveryRecord = null;
        recoveredReceipt = null;
        receiptPresent = false;
      }
      var epoch = begin();
      if (epoch === null) { render(); return; }
      try {
        if (typeof win.DataTransfer !== 'function') throw new Error('DataTransfer unavailable');
        var transfer = new win.DataTransfer();
        transfer.items.add(model.file);
        replaying = true;
        attr(input, 'data-tp-cc-replay', 'true');
        input.files = transfer.files;
        input.dispatchEvent(new win.Event('change', { bubbles: true }));
      } catch (_error) {
        model.fail(epoch, 'unsupported');
      } finally {
        replaying = false;
        if (input) input.removeAttribute('data-tp-cc-replay');
      }
      schedule();
    }
    function stopCart(event) {
      if (!mounted) return;
      // Check the displayed image synchronously: history selection followed
      // immediately by ATC must not beat the debounced mutation observer.
      syncWanted();
      observeProject(snapshot());
      render();
      if (!cartBlocked()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      cartAttempted = true;
      render();
      var action = panel.querySelector('[data-tp-cc-regenerate]');
      if (action && !panel.hidden && !action.hidden && !action.disabled) {
        action.scrollIntoView({ behavior: 'smooth', block: 'center' });
        action.focus({ preventScroll: true });
      } else if (cartStatus && !cartStatus.hidden) {
        cartStatus.scrollIntoView({ behavior: 'smooth', block: 'center' });
        cartStatus.focus({ preventScroll: true });
      }
    }
    root.addEventListener('change', function (event) {
      var input = event.target;
      var field = photoField();
      if (!replaying && !writingNative && input.type !== 'file') schedule();
      if (!field || !field.contains(input) || input.type !== 'file' || replaying || !input.files || !input.files.length) return;
      pristine = false;
      pendingHistoryDisplayUrl = '';
      ensurePanel();
      invalidateOriginal(false);
      model.setSource(input.files[0]);
      cartAttempted = false;
      syncWanted();
      var current = snapshot();
      if (model.pending() || model.unsettled || (current && current.busy) || !model.validText || !model.validContext) {
        // An in-flight native request may finish, but cannot validate this newly chosen file/text.
        event.preventDefault();
        event.stopImmediatePropagation();
        render();
        return;
      }
      begin();
      schedule();
    }, true);
    root.addEventListener('input', function (event) {
      if (!writingNative && (!panel || !panel.contains(event.target))) schedule();
    }, true);
    root.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      if (target.closest('[data-tp-cc-photo-remove]')) {
        event.preventDefault(); event.stopImmediatePropagation();
        openRemovalConfirmation(target.closest('[data-tp-cc-photo-remove]'));
        return;
      }
      var removalAction = target.closest('[data-tp-cc-photo-remove-action]');
      if (removalAction && removalConfirmation && removalConfirmation.contains(removalAction)) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (removalAction.getAttribute('data-tp-cc-photo-remove-action') === 'confirm') confirmPhotoRemoval();
        else closeRemovalConfirmation(true);
        syncPhotoRemoval();
        return;
      }
      if (target.closest(ATC_SELECTOR)) { hydrateNative(); pristine = false; stopCart(event); return; }
      var clear = target.closest('.tee-photo-clear');
      var field = photoField();
      var history = target.closest('.tee-photo-preview-history__item');
      if (history && field && field.contains(history) && (model.pending() || model.unsettled)) {
        // A history URL after the busy marker is not the request's result.
        // Do not let user history selection race the native asynchronous upload.
        event.preventDefault(); event.stopImmediatePropagation(); return;
      }
      if (history && field && field.contains(history) && !model.file) {
        restorationAllowed = false;
        // A history pick before restoration was observed has no request identity.
        if (!model.restored && model.successfulKey === null) model.previewMismatch = true;
      }
      if (history && field && field.contains(history)) requestHistoryDisplay(history);
      if (clear && field && field.contains(clear)) { pristine = false; pendingHistoryDisplayUrl = ''; invalidateOriginal(true); model.clear(); cartAttempted = false; render(); schedule(); }
    }, true);
    root.addEventListener('keydown', function (event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (event.key === 'Escape' && removalRequest) {
        event.preventDefault(); event.stopImmediatePropagation();
        closeRemovalConfirmation(true);
        syncPhotoRemoval();
        return;
      }
      var field = photoField();
      var historyAction = (event.key === 'Enter' || event.key === ' ') && target && field &&
        target.closest('.tee-photo-preview-history__item') && field.contains(target);
      if (historyAction && (model.pending() || model.unsettled)) {
        event.preventDefault(); event.stopImmediatePropagation();
      } else if (historyAction) {
        if (!model.file) {
          restorationAllowed = false;
          if (!model.restored && model.successfulKey === null) model.previewMismatch = true;
        }
        requestHistoryDisplay(target.closest('.tee-photo-preview-history__item'));
      }
    }, true);
    root.addEventListener('submit', function (event) {
      var form = event.target;
      var field = photoField();
      if (!form || !form.querySelector || !field) return;
      if (form.contains(field) || form.querySelector(ATC_SELECTOR) || form.matches('form[action*="/cart/add"]')) stopCart(event);
    }, true);
    var observer = new win.MutationObserver(schedule);
    observer.observe(root, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class', 'src'] });
    refresh();
  }

  function boot() { doc.querySelectorAll(ROOT_SELECTOR).forEach(mount); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  doc.addEventListener('teeinblue-event-component-injected', boot);
  doc.addEventListener('teeinblue:ready', boot);
  new win.MutationObserver(function (records) {
    var head = doc.head;
    if (records.length && head && records.every(function (record) {
      return head.contains(record.target);
    })) return;
    boot();
  }).observe(doc.documentElement, { childList: true, subtree: true });
});

